// src/redux/slices/searchTableRefetchSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ESearchTableType } from "src/types/global_enums";

export interface ISearchTableRefreshState {
    refetchTriggers: {
        [key in ESearchTableType]: number;
    };
}

export const initialSearchTableRefetchState: ISearchTableRefreshState = {
    refetchTriggers: {
        [ESearchTableType.CSL_CURRENT_INVENTORY]: 0,
        [ESearchTableType.CSL_CONTAINER_LOGS]: 0,
    },
};

const searchTableRefetchSlice = createSlice({
    name: "searchTableRefetch",
    initialState: initialSearchTableRefetchState,
    reducers: {
        triggerSearchTableRefetch: (state, action: PayloadAction<ESearchTableType[]>) => {
            action.payload.forEach((tableType) => {
                state.refetchTriggers[tableType]++;
            });
        },
    },
});

export const { triggerSearchTableRefetch } = searchTableRefetchSlice.actions;
export default searchTableRefetchSlice.reducer;
